import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding: ", ";\n\t\t\t"]);

  _templateObject14 = function () {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-bottom: ", ";\n\t\t\t\tpadding-top: ", ";\n\t\t\t"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-left: ", ";\n\t\t\t\tpadding-right: ", ";\n\t\t\t"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-right: ", ";\n\t\t\t"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-left: ", ";\n\t\t\t"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-bottom: ", ";\n\t\t\t"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-top: ", ";\n\t\t\t"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin: ", ";\n\t\t\t"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin-bottom: ", ";\n\t\t\t\tmargin-top: ", ";\n\t\t\t"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin-left: ", ";\n\t\t\t\tmargin-right: ", ";\n\t\t\t"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin-right: ", ";\n\t\t\t"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin-left: ", ";\n\t\t\t"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin-bottom: ", ";\n\t\t\t"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin-top: ", ";\n\t\t\t"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { useContextSystem } from '@wp-g2/context';
import { css, cx, space } from '@wp-g2/styles';
import { is } from '@wp-g2/utils';
export function useSpacer(props) {
  var _useContextSystem = useContextSystem(props, 'Spacer'),
      className = _useContextSystem.className,
      m = _useContextSystem.m,
      _useContextSystem$mb = _useContextSystem.mb,
      mb = _useContextSystem$mb === void 0 ? 2 : _useContextSystem$mb,
      ml = _useContextSystem.ml,
      mr = _useContextSystem.mr,
      mt = _useContextSystem.mt,
      mx = _useContextSystem.mx,
      my = _useContextSystem.my,
      p = _useContextSystem.p,
      pb = _useContextSystem.pb,
      pl = _useContextSystem.pl,
      pr = _useContextSystem.pr,
      pt = _useContextSystem.pt,
      px = _useContextSystem.px,
      py = _useContextSystem.py,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "m", "mb", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py"]);

  var classes = cx(is.defined(mt) && css(_templateObject(), space(mt)), is.defined(mb) && css(_templateObject2(), space(mb)), is.defined(ml) && css(_templateObject3(), space(ml)), is.defined(mr) && css(_templateObject4(), space(mr)), is.defined(mx) && css(_templateObject5(), space(mx), space(mx)), is.defined(my) && css(_templateObject6(), space(my), space(my)), is.defined(m) && css(_templateObject7(), space(m)), is.defined(pt) && css(_templateObject8(), space(pt)), is.defined(pb) && css(_templateObject9(), space(pb)), is.defined(pl) && css(_templateObject10(), space(pl)), is.defined(pr) && css(_templateObject11(), space(pr)), is.defined(px) && css(_templateObject12(), space(px), space(px)), is.defined(py) && css(_templateObject13(), space(py), space(py)), is.defined(p) && css(_templateObject14(), space(p)), className);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes
  });
}